import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography
} from '@mui/material';

const ModalConfirmacaoConta = ({ open, onClose, aplicaContacorrente, loadingBtnConfirmarConta }) => {
  const handleClose = (event, reason) => {
    if (reason === 'backdropClick') return;
    if (reason === 'escapeKeyDown') return;
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="xs" fullWidth className="dialog-conta">
      <DialogTitle className="titulo-modal">Confirmar a conta bancária?</DialogTitle>

      <DialogContent className="dialog-conta__content">
        <Typography variant="body2" className="dialog-conta__subtitle">
          Uma vez enviada a conta bancária não será possível mudar essa conta para receber futuramente
          nessa operação.
        </Typography>
      </DialogContent>

      <DialogActions className="dialog-conta__actions modal-confirmacao-conta">
        <Button
          variant="outlined"
          color="inherit"
          onClick={onClose}
          className="dialog-conta__btn-cancelar"
          disabled={loadingBtnConfirmarConta}
        >
          Cancelar
        </Button>

        <Button
          variant="contained"
          onClick={() => aplicaContacorrente()}
          className="dialog-conta__btn-escolher"
          disabled={loadingBtnConfirmarConta}
        >
          {!loadingBtnConfirmarConta && <>Confirmar</>}
          {loadingBtnConfirmarConta && (
            <>
              Confirmando &nbsp;
              <CircularProgress size={20} color="inherit" />
            </>
          )}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ModalConfirmacaoConta;
